import {
  Label,
  Language,
  QuestionGroupSortInput,
  RevisionDocumentInput,
  Scalars
} from '@generated/base-types';
import { ManagerError } from '@new/common/utils/error-parser';
import { TaskQuestionGroup } from '../../../lib/types';

/* Query actions */

export class LoadTaskQuestionGroups {
  public static readonly type = '[TaskQuestionGroups] Load';
  constructor(public readonly taskIds: string[]) {}
}

export class LoadTaskQuestionGroupsSuccess {
  public static readonly type = '[TaskQuestionGroups] Load success';
  constructor(public readonly taskQuestionGroups: TaskQuestionGroup[]) {}
}

export class LoadTaskQuestionGroupsFailure {
  public static readonly type = '[TaskQuestionGroups] Load failure';
  constructor(public readonly error: ManagerError) {}
}

export class SetSelectedIds {
  public static readonly type = '[TaskQuestionGroups] Set selected IDs';
  constructor(public readonly taskQuestionGroups: TaskQuestionGroup[]) {}
}

export class ResetSelectedIds {
  public static readonly type = '[TaskQuestionGroups] Reset selected IDs';
}

export class ResetTableState {
  public static readonly type = '[TaskQuestionGroups] Reset table state';
}

export class SetSortAttributes {
  public static readonly type = '[TaskQuestionGroups] Set sort attributes';
  constructor(public sortAttributes?: QuestionGroupSortInput[]) {}
}

export class ResetSortAttributes {
  public static readonly type = '[TaskQuestionGroups] Reset sort attributes';
}

/* Mutation actions */

export class Failure {
  public static readonly type = '[TaskQuestionGroups] Mutation failure';
  constructor(public readonly error: ManagerError) {}
}

export class DeleteQuestionGroups {
  public static readonly type = '[TaskQuestionGroups] Delete QGs';
  constructor(public readonly questionGroupIds: Scalars['ID'][]) {}
}

export class DeleteQuestionGroupsSuccess {
  public static readonly type = '[TaskQuestionGroups] Delete QGs success';
  constructor(public readonly questionGroupIds: Scalars['ID'][]) {}
}

export class SetSupervisor {
  public static readonly type = '[TaskQuestionGroups] Set supervisor';
  constructor(
    public readonly supervisor: string,
    public readonly questionGroupIds: Scalars['ID'][]
  ) {}
}

export class SetSupervisorSuccess {
  public static readonly type = '[TaskQuestionGroups] Set supervisor success';
  constructor(
    public readonly supervisor: string,
    public readonly questionGroupIds: Scalars['ID'][]
  ) {}
}

export class SetRevisionYear {
  public static readonly type = '[TaskQuestionGroups] Set revision year';
  constructor(
    public readonly revisionYear: number,
    public readonly questionGroupIds: Scalars['ID'][]
  ) {}
}

export class SetRevisionYearSuccess {
  public static readonly type =
    '[TaskQuestionGroups] Set revision year success';
  constructor(
    public readonly revisionYear: number,
    public readonly questionGroupIds: Scalars['ID'][]
  ) {}
}

export class SetAffiliation {
  public static readonly type = '[TaskQuestionGroups] Set affiliation';
  constructor(
    public readonly affiliationId: Scalars['ID'],
    public readonly questionGroupIds: Scalars['ID'][]
  ) {}
}

export class SetAffiliationSuccess {
  public static readonly type = '[TaskQuestionGroups] Set affiliation success';
  constructor(
    public readonly affiliationId: Scalars['ID'],
    public readonly questionGroupIds: Scalars['ID'][]
  ) {}
}

export class SetSourceLanguage {
  public static readonly type = '[TaskQuestionGroups] Set source language';
  constructor(
    public readonly language: Language,
    public readonly questionGroupIds: Scalars['ID'][]
  ) {}
}

export class SetSourceLanguageSuccess {
  public static readonly type =
    '[TaskQuestionGroups] Set source language success';
  constructor(
    public readonly language: Language,
    public readonly questionGroupIds: Scalars['ID'][]
  ) {}
}

export class SetBlueprint {
  public static readonly type = '[TaskQuestionGroups] Set blueprint';
  constructor(
    public readonly categories: Scalars['ID'][],
    public readonly questionGroupIds: Scalars['ID'][]
  ) {}
}

export class SetBlueprintSuccess {
  public static readonly type = '[TaskQuestionGroups] Set blueprint success';
}

export class SetRevisionStatus {
  public static readonly type = '[TaskQuestionGroups] Set revision status';
  constructor(
    public readonly revisionStatusId: Scalars['ID'] | null,
    public readonly questionGroupIds: Scalars['ID'][]
  ) {}
}

export class SetRevisionStatusSuccess {
  public static readonly type =
    '[TaskQuestionGroups] Set revision status success';
  constructor(
    public readonly revisionStatusId: Scalars['ID'] | null,
    public readonly questionGroupIds: Scalars['ID'][]
  ) {}
}

export class CreateRevisionDocument {
  public static readonly type = '[TaskQuestionGroups] Create revision document';
  constructor(public readonly displayOptions: RevisionDocumentInput) {}
}

export class CreateRevisionDocumentSuccess {
  public static readonly type =
    '[TaskQuestionGroups] Create revision document success';
}

export class AssignExam {
  public static readonly type = '[TaskQuestionGroups] Assign exam';
  constructor(
    public readonly questionGroupIds: Scalars['ID'][],
    public readonly examIdsToAdd: Scalars['ID'][],
    public readonly examIdsToRemove: Scalars['ID'][]
  ) {}
}

export class AssignExamSuccess {
  public static readonly type = '[TaskQuestionGroups] Assign exam success';
  constructor(
    public readonly questionGroupIds: Scalars['ID'][],
    public readonly examIdsToAdd: Scalars['ID'][],
    public readonly examIdsToRemove: Scalars['ID'][]
  ) {}
}

export class AssignQGLabels {
  public static readonly type = '[TaskQuestionGroups] Assign QG labels';
  constructor(
    public readonly labelIdsToAdd: Scalars['ID'][],
    public readonly labelIdsToRemove: Scalars['ID'][],
    public readonly questionGroupIds: Scalars['ID'][]
  ) {}
}

export class AssignQGLabelsSuccess {
  public static readonly type = '[TaskQuestionGroups] Assign QG labels success';
  constructor(
    public readonly labelIdsToAdd: Scalars['ID'][],
    public readonly labelIdsToRemove: Scalars['ID'][],
    public readonly questionGroupIds: Scalars['ID'][]
  ) {}
}

export class UpdateQGLabel {
  public static readonly type = '[TaskQuestionGroups] Update QG label';
  constructor(public readonly label: Label) {}
}

export class RemoveQGLabel {
  public static readonly type = '[TaskQuestionGroups] Remove QG label';
  constructor(public readonly id: Label['id']) {}
}
